import L from 'leaflet';

export default new L.Icon({
  iconUrl: '/icons/soccer-field.svg',
  iconRetinaUrl: '/icons/soccer-field.svg',
  iconAnchor: [0, 0],
  popupAnchor: [10, -5],
  iconSize: [20, 20],
});